import { isRuleGroup } from './index';

/**
 * Formats a query in the requested output format.  The optional
 * `valueProcessor` argument can be used to format the values differently
 * based on a given field, operator, and value.  By default, values are
 * processed assuming the default operators are being used.
 * @param {RuleGroup} ruleGroup
 * @param {"json"|"sql"} format
 * @param {Function} valueProcessor
 */
const formatQuery = (ruleGroup, format, valueProcessor) => {
  if (format.toLowerCase() === 'json') {
    return JSON.stringify(ruleGroup, null, 2);
  } else if (format.toLowerCase() === 'sql') {
    const valueProc =
      valueProcessor ||
      ((field, operator, value) => {
        if (operator.toLowerCase()==="like") {
          value="%"+value+"%";
        }
        let val = `"${value}"`;
        if (field.includes("format_date")) {
          if (val!=="") {
            var d = new Date(val);
            val = '"' + d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate() + '"';
          }
        }

        if (operator.toLowerCase() === 'is null' || operator.toLowerCase() === 'is not null') {
          val = '';
        } else if (operator.toLowerCase() === 'in' || operator.toLowerCase() === 'not in') {
          val = `(${value
            .split(',')
            .map((v) => `"${v.trim()}"`)
            .join(', ')})`;
        } else if (typeof value === 'boolean') {
          val = `${value}`.toUpperCase();
        }
        return val;
      });

    const processRule = (rule) => {
      const value = valueProc(rule.field, rule.operator, rule.value);

      let operator = rule.operator;
      if (rule.operator.toLowerCase() === 'null') {
        operator = 'is null';
      } else if (rule.operator.toLowerCase() === 'is not null') {
        operator = 'is not null';
      } else if (rule.operator.toLowerCase() === 'not in') {
        operator = 'not in';
      }

      return `${rule.field} ${operator} ${value}`.trim();
    };

    const processRuleGroup = (rg) => {
      const processedRules = rg.rules.map((rule) => {
        if (isRuleGroup(rule)) {
          return processRuleGroup(rule);
        }
        return processRule(rule);
      });
      return `${rg.not ? 'NOT ' : ''}(${processedRules.join(` ${rg.combinator} `)})`;
    };

    return processRuleGroup(ruleGroup);
  } else {
    return '';
  }
};

export default formatQuery;
